import { render, staticRenderFns } from "./MallPointModal.vue?vue&type=template&id=780dcceb&scoped=true&"
import script from "./MallPointModal.vue?vue&type=script&lang=js&"
export * from "./MallPointModal.vue?vue&type=script&lang=js&"
import style0 from "./MallPointModal.vue?vue&type=style&index=0&id=780dcceb&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780dcceb",
  null
  
)

export default component.exports